// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__HBr8_","colCheckbox":"styles_colCheckbox__1pVuB"};